import { SVGProps } from "react";

export const CalendarCheck2Icon = ({
  size = 16,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg fill="none" viewBox="0 0 24 24" width={size} height={size} {...rest}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M12.437 21.5H0.5v-14h18v4"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M0.5 7.5v-5h18v5"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M9.5 4.5v-3"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M14.5 4.5v-3"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M4.5 4.5v-3"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m22.5 20.75 -4 2.25 -4 -2.25v-4.5l4 -2.25 4 2.25v4.5Z"
        strokeWidth="1"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M16.5 18.5 18 20l2.5 -3"
        strokeWidth="1"
      />
    </svg>
  );
  return render();
};
